import { createAction } from "@reduxjs/toolkit";

/**
 * The two logout actions, on their own so a slice can reset on them without importing the login
 * slice's helpers (`./shared` reaches v1's `catalogueHelpers` and, through it, the browser history).
 * `./shared` re-exports them, so its importers are unchanged; its header has the full story.
 *
 * The action type strings are the public contract. Do not rename them.
 */
export const userLogout = createAction("auth/userLogout");
export const supportLogout = createAction("auth/supportLogout");
